import { gql } from '@apollo/client';

const SAVE_TOUR_SETTING = gql`
  mutation saveToursSettings($data: SaveToursSettingsInput!) {
    saveToursSettings(data: $data) {
      tourId
    }
  }
`;

export default SAVE_TOUR_SETTING;
